export const RATING_LABELS = [' оценка', ' оценки', ' оценок'];
export const DEFAULT_APPS_TITLE = 'RuStore — Каталог приложений для Android';
export const DEFAULT_GAMES_TITLE = 'RuStore — Каталог игр для Android';
export const DEFAULT_VK_MINI_APPS_TITLE =
  'RuStore — Каталог VK mini apps для Android';

export const DEFAULT_DESCRIPTION =
  // eslint-disable-next-line max-len
  'RuStore — это Российский магазин мобильных Android-приложений, которые отвечают стандартам качества, конфиденциальности и защиты данных';
export const DEFAULT_GAMES_DESCRIPTION =
  'Игры в RuStore — популярные мобильные игры в Российском магазине мобильных Android-приложений';

export const ScreenshotTab = {
  TABLET: 'TABLET',
  MOBILE: 'MOBILE',
} as const;

export const DOMAIN = 'https://www.rustore.ru/catalog';

export const DEFAULT_OG_IMAGE =
  'https://static.rustore.ru/image/rustore_deeplink_600x315.jpg';

export const DEFAULT_SITE_NAME = 'RuStore';
